<template>
  <div class="app-container fee-info-page">
    <el-tabs v-model="activeTab" type="card">
      <!-- 应收 -->
      <el-tab-pane v-if="showReceivable" :label="$t('feeTab.receivable')" name="receivable" lazy>
        <ReceivablePage :fee-item-list="QUOTATION_FEE_ITEM" :charge-unit-list="QUOTATION_CHARGE_UNIT" :outer-order-no="outerOrderNo" />
      </el-tab-pane>
      <!-- 应付 -->
      <el-tab-pane v-if="showPayable" :label="$t('feeTab.payable')" name="payable" lazy>
        <PayablePage :fee-item-list="QUOTATION_FEE_ITEM" :charge-unit-list="QUOTATION_CHARGE_UNIT" :outer-order-no="outerOrderNo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  QUOTATION_FEE_ITEM,
  QUOTATION_CHARGE_UNIT,
  loadQuotationOptions,
} from '@/utils/quotationOptions';
import ReceivablePage from './components/ReceivablePage.vue';
import PayablePage from './components/PayablePage.vue';

const RECEIVABLE_PERMISSION = 'BusinessOrderFeeTabReceivable'.toLocaleLowerCase();
const PAYABLE_PERMISSION = 'BusinessOrderFeeTabPayable'.toLocaleLowerCase();

export default {
  name: 'BusinessOrderInternalCSGFEE',
  components: {
    ReceivablePage,
    PayablePage,
  },
  data() {
    return {
      activeTab: 'receivable',
      QUOTATION_FEE_ITEM,
      QUOTATION_CHARGE_UNIT,
    };
  },
  computed: {
    outerOrderNo() {
      return this.$route.query.outerOrderNo;
    },
    permissionBtns() {
      return this.$store.getters.userPermissionBtns || [];
    },
    showReceivable() {
      return [RECEIVABLE_PERMISSION, PAYABLE_PERMISSION].some(permission => this.permissionBtns.includes(permission));
    },
    showPayable() {
      return this.permissionBtns.includes(PAYABLE_PERMISSION);
    },
  },
  mounted() {
    loadQuotationOptions();
  },
};
</script>

<style lang="scss" scoped>
.fee-info-page {
  ::v-deep .el-tabs__header {
    margin-bottom: 16px;
  }
}
</style>
